"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGBA = void 0;
var convertHexToRGBA = exports.convertHexToRGBA = function convertHexToRGBA(hexCode, opacity) {
  var hex = hexCode.replace('#', '');
  if (hex.length === 3) {
    hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
  }
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity, ")");
};